import {
    getInputsForBroker,
} from "./inputReader";
import {calcAjaxCall} from "./ajax";
import containerElement from "../helpers/containerElement";

const initNatgasCalculator = () => {
    if (!document.querySelector('.natgascalculator') || document.querySelector('.is-free-membership')) {
        return;
    }

    // add event listeners:
    let inputs = document.querySelectorAll(['.natgascalculator__input-section input', '.natgascalculator__input-section select']);
    inputs.forEach(c => {
        c.addEventListener('change', onInputChange);
    });

    document.querySelectorAll('.natgas-do-calculate').forEach((el, index) => {
        el.addEventListener('click', natgasCalculate);
    });

    document.querySelectorAll('.natgas-do-share-deal').forEach((el, index) => {
        el.addEventListener('click', natgasShareDeal);
    });

}

const natgasSetLastCalc = (e, val) => {
    let container = null;
    if(typeof e ==='object' && e.target) {
        container = containerElement(e.target);
    } else {
        container = e;
    }

    container.setAttribute('data-last-calc', val);
}

const natgasGetLastCalc = (e) => {
    let container = containerElement(e.target);
    const ret = container.getAttribute('data-last-calc');
    return ret;
}


const natgasShareDeal = (e) => {
    const lastCalc = natgasGetLastCalc(e);

    if (!lastCalc) {
        alert('Plese click the calculate button first.');
        return;
    }

    const containerEl = containerElement(e.target);
    const brokerInputs = {
        '1': getInputsForBroker(containerEl, 1),
        '2': getInputsForBroker(containerEl, 2)
    }

    if(!brokerInputs['1']['broker'] || !brokerInputs['1']['broker'] ) {
        alert('Please enter the brokers before sharing.');
        return;
    }

    const swapTypes = [
        brokerInputs['1'].swap_type,
        brokerInputs['2'].swap_type
    ];

    const resFetch = calcAjaxCall(containerEl, lastCalc, 'share_deal');

    resFetch.then((result) => {
            const output = result.json();
            //alert('Deal shared!');
            containerEl.querySelector('.deal-info-msg').innerHTML = 'Thank you for sharing this Deal!';
        }
    );
}


/***
 * Main calc function, re-renders all outputs in a single step
 */
const natgasCalculate = (e) => {
    const containerEl = containerElement(e.target);

    const brokerInputs = {
        '1': getInputsForBroker(containerEl, 1),
        '2': getInputsForBroker(containerEl, 2)
    }

    const swapTypes = [
        brokerInputs['1'].swap_type,
        brokerInputs['2'].swap_type
    ];

    if (swapTypes[0] === 'points' && swapTypes[1] === 'points') {
        updateOutputsSwapTypePointsPoints(containerEl);
    } else if (swapTypes[0] === 'USD' && swapTypes[1] === 'points') {
        updateOutputsSwapTypeUsdPoints(containerEl);
    } else if (swapTypes[0] === 'points' && swapTypes[1] === 'USD') {
        updateOutputsSwapTypePointsUsd(containerEl);
    } else if (swapTypes[0] === 'USD' && swapTypes[1] === 'USD') {
        updateOutputsSwapTypeUsdUsd(containerEl);
    } else {
        console.error('Cannot update outputs - scenario not implemented');
    }
}

const printOutputs = (containerEl, outputJsonResp) => {
    outputJsonResp.then(output => {

        // console.log('output:');
        // console.log(output);

        const cssPrefix = '.natgascalculator__output-scenario ';
        setOutputField(containerEl, cssPrefix, 'fund-broker-1', 'input[type=text]', output['fund_broker1']);
        setOutputField(containerEl, cssPrefix, 'fund-broker-2', 'input[type=text]', output['fund_broker2']);
        setOutputField(containerEl, cssPrefix, 'trade-cost-clears-in', 'input[type=text]', output['trade_cost_clears_in']);
        setOutputField(containerEl, cssPrefix, 'multiplier', 'input[type=text]', output['multiplier']);
        setOutputField(containerEl, cssPrefix, 'monthly-return', 'input[type=text]', output['monthly_return']);
        setOutputField(containerEl, cssPrefix, 'trade-size-1', 'input[type=text]', output['trade_size1']);
        setOutputField(containerEl, cssPrefix, 'trade-size-2', 'input[type=text]', output['trade_size2']);
        //setOutputField(containerEl,cssPrefix, 'fund-broker-1-currency', '', 'GBP');
        //setOutputField(containerEl,cssPrefix, 'fund-broker-2-currency', '', 'GBP');

        if (containerEl.querySelector('natgas-div-console')) {
            containerEl.querySelector('natgas-div-console').innerText = JSON.stringify(output['iv']);
        }
    });
}

const updateOutputsSwapTypePointsPoints = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'points-points');
    natgasSetLastCalc(containerEl, 'points-points');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypeUsdPoints = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'usd-points');
    natgasSetLastCalc(containerEl, 'usd-points');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypePointsUsd = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'points-usd');
    natgasSetLastCalc(containerEl, 'points-usd');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const updateOutputsSwapTypeUsdUsd = (containerEl) => {
    const resFetch = calcAjaxCall(containerEl, 'usd-usd');
    natgasSetLastCalc(containerEl, 'usd-usd');

    resFetch.then((result) => {
            const output = result.json();
            printOutputs(containerEl, output);
        }
    );
}

const setOutputField = (containerEl, cssPrefix, fieldName, inputType, val) => {
    //console.log(fieldName);

    if (fieldName === 'monthly-return') {
        containerEl.querySelector(cssPrefix + ' .monthly-return ').innerHTML = val;
        return;
    }

    if (inputType) {
        containerEl.querySelector(cssPrefix + ' [data-field="' + fieldName + '"] ' + inputType).value = val;
    } else {
        containerEl.querySelector(cssPrefix + ' [data-label="' + fieldName + '"] ' + inputType).innerHTML = val;
    }
}

const onInputChange = (e) => {
    natgasCalculate(e);
    //alert("Input changed");
}

initNatgasCalculator();
